export type OAuthProvider = {
  key: "google" | "facebook"
  action: string
  labelKey: string
  testId: string
}

export const OAUTH_PROVIDERS: OAuthProvider[] = [
  {
    key: "google",
    action: "/users/auth/google_oauth2",
    labelKey: "app.auth.login.google",
    testId: "auth-signin-google-oauth-btn",
  },
  {
    key: "facebook",
    action: "/users/auth/facebook",
    labelKey: "app.auth.login.facebook",
    testId: "auth-signin-facebook-oauth-btn",
  },
]
